module.exports = __webpack_public_path__ + "static/media/hide-01.57fd6298.svg";